module.exports = __webpack_public_path__ + "img/content-03.9f35f6c5.jpg";